import { render, staticRenderFns } from "./WizardComponent.vue?vue&type=template&id=ae1b63ec&scoped=true"
import script from "./WizardComponent.vue?vue&type=script&lang=js"
export * from "./WizardComponent.vue?vue&type=script&lang=js"
import style0 from "./WizardComponent.vue?vue&type=style&index=0&id=ae1b63ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae1b63ec",
  null
  
)

export default component.exports